import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import {
  MOBILE_PAGE_PAD_X,
  MOBILE_TOUCH_MIN_PX,
  MOBILE_TYPE,
  mobileStickyBarBottom,
} from "../../../theme/mobileLayout";

/**
 * Sticky bottom action bar for spreadsheet selection on mobile.
 * Sits above the app bottom navigation.
 */
export default function MobileBulkActionBar({
  selectedCount = 0,
  onClear,
  onExport,
  onSaveSearch,
  isExporting = false,
  exportDisabled = false,
  saveDisabled = false,
}) {
  if (selectedCount <= 0) return null;

  return (
    <Box
      data-testid="mobile-bulk-action-bar"
      sx={{
        display: { xs: "flex", md: "none" },
        position: "fixed",
        left: 0,
        right: 0,
        bottom: mobileStickyBarBottom,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        alignItems: "center",
        gap: 1,
        px: MOBILE_PAGE_PAD_X,
        py: 1.25,
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
        boxShadow: "0 -4px 16px rgba(15, 23, 42, 0.08)",
      }}
    >
      <Typography sx={{ ...MOBILE_TYPE.secondary, fontWeight: 700, flex: 1, minWidth: 0 }}>
        {selectedCount} selected
      </Typography>
      <Button
        size="small"
        onClick={onClear}
        sx={{ ...MOBILE_TYPE.button, minHeight: MOBILE_TOUCH_MIN_PX, minWidth: 0, px: 1 }}
      >
        Clear
      </Button>
      <Button
        size="small"
        variant="outlined"
        onClick={onSaveSearch}
        disabled={saveDisabled}
        sx={{ ...MOBILE_TYPE.button, minHeight: MOBILE_TOUCH_MIN_PX, borderRadius: 2 }}
      >
        Save
      </Button>
      <Button
        size="small"
        variant="contained"
        onClick={onExport}
        disabled={exportDisabled || isExporting}
        sx={{
          ...MOBILE_TYPE.button,
          minHeight: MOBILE_TOUCH_MIN_PX,
          borderRadius: 2,
          boxShadow: "none",
          minWidth: 72,
        }}
      >
        {isExporting ? <CircularProgress size={16} color="inherit" /> : "Export"}
      </Button>
    </Box>
  );
}

MobileBulkActionBar.propTypes = {
  selectedCount: PropTypes.number,
  onClear: PropTypes.func,
  onExport: PropTypes.func,
  onSaveSearch: PropTypes.func,
  isExporting: PropTypes.bool,
  exportDisabled: PropTypes.bool,
  saveDisabled: PropTypes.bool,
};
